module.exports = __webpack_public_path__ + "img/gestao-e-governanca.a0e54723.jpg";